var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-0"},[_c('h5',{staticClass:"page-panel-title"},[_vm._v(_vm._s(_vm.headerTitle))]),_vm._v(" "),(_vm.headerSubtitle)?_c('p',{staticClass:"page-panel-subtitle"},[_vm._v(_vm._s(_vm.headerSubtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61766014","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/PanelHeader.vue
// module id = He1F
// module chunks = 107